import React, { CSSProperties, FC, ReactElement, useRef } from 'react';
import styles from './button.module.scss';
import { WCircularProgress } from 'components/wrappers/wrapper';

interface ButtonProps {
  children: ReactElement | string;
  className?: string;
  style?: CSSProperties;
  disabled?: boolean;
  loading?: boolean;
  radius?: string;
  type?: 'primary' | 'danger' | 'primaryOutline' | 'dangerOutline' | 'success' | 'base';
  fontSize?: string;
  loadingSize?: number;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}
const Button: FC<ButtonProps> = (props) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const {
    disabled,
    children,
    loading,
    style,
    className,
    radius,
    fontSize,
    loadingSize = 14,
    type = 'primary',
    onClick,
  } = props;

  const buttonClasses = `
    ${styles.buttonAttom} 
    ${type === 'base' ? styles.base : ''}
    ${type === 'primary' ? styles.primary : ''} 
    ${type === 'danger' ? styles.danger : ''} 
    ${type === 'primaryOutline' ? styles.primaryOutline : ''} 
    ${type === 'dangerOutline' ? styles.dangerOutline : ''} 
    ${type === 'success' ? styles.success : ''} 
    ${className || ''}`.trim();

  const customStyle = {
    ...style,
    fontSize,
    borderRadius: radius,
    minWidth: buttonRef?.current?.offsetWidth,
  };

  return (
    <button
      ref={buttonRef}
      disabled={disabled}
      className={buttonClasses}
      style={customStyle}
      onClick={onClick}
    >
      {loading ? <WCircularProgress size={loadingSize} className={styles.loading} /> : children}
    </button>
  );
};

export default Button;
